import * as React from "react";
import { Button } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";

export default function EditToolbar(props) {
    const { handleAddPointClick, handleBulkAddPointsClick, pointType } = props;
    const { t } = useTranslation();

    return (
        <GridToolbarContainer>
            <Button
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => handleAddPointClick()}
            >
                {t(`Add${" " + pointType} Point`)}
            </Button>
            {pointType !== "occupancy" && (
                <Button
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={() => handleBulkAddPointsClick()}
                >
                    {t(`Bulk Import${" " + pointType} Points (csv)`)}
                </Button>
            )}
        </GridToolbarContainer>
    );
}
